import { BaseRouteService } from 'core/services';

class SalesOrderRouteService extends BaseRouteService {
    constructor() {
        super('sales-orders');
    }

    find(filter) {
        return super.find(this.base + '/{?patientId,page,rpp,sort}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }
}

export default SalesOrderRouteService;